import { colors } from '~src/theme/colors';

export const getBorderColor = (
  focused?: boolean,
  error?: boolean,
  warning?: boolean,
  disabled?: boolean
) => {
  if (error) {
    return colors.error35;
  } else if (focused) {
    return colors.black;
  } else if (warning) {
    return colors.darkOrange;
  } else if (disabled) {
    return colors.superlightGrey;
  }

  return colors.neutral85;
};

export const getLabelColor = (error?: boolean, warning?: boolean, disabled?: boolean) => {
  if (error) {
    return colors.error35;
  } else if (warning) {
    return colors.darkOrange;
  } else if (disabled) {
    return colors.grey;
  }

  return colors.neutral35;
};
